import {
  IUseCreateStaff,
  useCreateStaff,
} from "../../common/staff/staff";

export const useCreateStaffCaller = (): IUseCreateStaff => {
  const {
    onSubmit,
    formValue,
    setFormValue,
    registerGeneral,
    handleSubmitGeneral,
    errorsGeneral,
    registerAddress,
    handleSubmitAddress,
    unRegisterAddress,
    errorsAddress,
    branch,
    appendAddress,
    addressFields,
    addressRemove,
    loading,
  } = useCreateStaff();

  return {
    onSubmit,
    formValue,
    setFormValue,
    registerGeneral,
    handleSubmitGeneral,
    errorsGeneral,
    registerAddress,
    handleSubmitAddress,
    unRegisterAddress,
    errorsAddress,
    branch,
    appendAddress,
    addressFields,
    addressRemove,
    loading,
  };
};
